module.exports = __webpack_public_path__ + "static/4-15eb74a2adfd884a808af05e4a92dbb0.jpg";